window.BLX = (function(BLX) {
	var atEnd = [];
	BLX.atEnd = function(f) {
		if (BLX.finishedDocument) {
			setTimeout(f, 0);
		} else {
			atEnd.push(f);
		}
	}
	
	BLX.finishDocument = function() {
		if (BLX.finishedDocument) return;
		BLX.finishedDocument = true;
		
		$(document).on('shown.bs.modal', '.modal[data-parent]', function() {
			var be = $(this).attr('data-parent');
			var b = $(be)[0] || document.body;
			var p = this.parentNode;
			var ns = this.nextSibling;
			var e = this;
			
			$(e).on('hide.bs.modal', function() {
				p.insertBefore(e, ns);
			});
			
			b.appendChild(e);
		});
	
		/* Offcanvas jQuery (Side navigation) */
		$(document).ready(function () {
			var transitionTimeOnSlide = 300;
			var flag = false;
			
			document.body.addEventListener('click', function(event) {
				var T = $(event.target);
				if (T.parents('.modal').length) return;
				if (T.parents('.sidebar-offcanvas').length) return;
				hideMainNav();
			}, true);
			
			function showMainNav() {
				var nav = $('.main-nav.row-offcanvas');
				if (nav.is('.transitioning') || nav.is('.active'))
					return;
				
				$('body').addClass('sidebar-active');
				nav.addClass('transitioning');
				if ($.support.transition)
					nav.one($.support.transition.end, function() {
						nav.addClass('active').removeClass('transitioning');
					}).emulateTransitionEnd(transitionTimeOnSlide);
				else
					nav.addClass('active').removeClass('transitioning');
			}
	
			function hideMainNav() {
				var nav = $('.main-nav.row-offcanvas');
				if (nav.is('.transitioning') || !nav.is('.active'))
					return;
				
				nav.addClass('transitioning');
				if ($.support.transition)
					nav.one($.support.transition.end, function() {
						nav.removeClass('active transitioning');
						nav.find('.sidebar-offcanvas').find('.nav-tabs .active, .tab-content .active').removeClass('active in fade');					
						$('body').removeClass('sidebar-active');
						setTimeout(function() {
							window.requestAnimationFrame(function() {
								var T = $(window).scrollTop();
								$(window).scrollTop(T+1);
								window.requestAnimationFrame(function() {
									$(window).scrollTop(T); 
								});
							});
						}, transitionTimeOnSlide);
					}).emulateTransitionEnd(transitionTimeOnSlide);
				else {
					nav.removeClass('transitioning active');
					nav.find('.sidebar-offcanvas').find('.nav-tabs .active, .tab-content .active').removeClass('active in fade');
					$('body').removeClass('sidebar-active');
					window.requestAnimationFrame(function() {
						var T = $(window).scrollTop();
						$(window).scrollTop(T+1);
						window.requestAnimationFrame(function() {
							$(window).scrollTop(T); 
						});
					});
				}
			}
			
			$('#sidebar .nav-tabs a').on('show.bs.tab', function(e) {
				showMainNav();
			});
			
			$('[data-toggle="main-nav-offcanvas"]').on('touchstart click', function(e){
				var nav = $('.main-nav.row-offcanvas');
				if (nav.is('.transitioning'))
					return;
				
				if (nav.is('.active'))
					hideMainNav();
				else
					nav.find('.sidebar-offcanvas .nav-tabs a[data-toggle="tab"]:eq(0)').tab('show');
					
				return false;
			});
			
			$(window).on('resize.sidebar-tabs', function() {
				var mcc = $('#contentContainer')[0];
				if (mcc) {
					var tabMargin = mcc.offsetWidth - mcc.clientWidth;
					$('#sidebar .nav.nav-tabs').css('margin-right', tabMargin);
					$('.btn-mobile-menu').css('margin-right', tabMargin);
				}
			}).triggerHandler('resize.sidebar-tabs'); 
		});
		
		/* Modal helper code: this disables vertical scrolling by force in Safari on iOS.
		 * Essentially, if a modal is open, grab the first touch. As it moves, check to see if it's
		 * an attempt to scroll up/down; if it is and we are at the top/bottom of the modal,
 	 	 * ignore it. */
		// Tracking

		var clickedSubmitButton = false;
		$(document.documentElement).on('click', '[data-spin]', function(e) {
			if ($(this).is('.spinning')) {
				e.preventDefault();
				return;
			}
			if ($(this).is('button') && this.type == 'submit') {
				clickedSubmitButton = this;
				return;
			}
			$(this).addClass('spinning');
		});
		$(document.documentElement).on('submit', 'form:has([data-spin])', function(event) {
			if (!clickedSubmitButton) return;
			if ($.contains(this, clickedSubmitButton) && !event.isDefaultPrevented()) {
				$(clickedSubmitButton).addClass('spinning');
			}
		});
		$(document.documentElement).on('hidden.bs.modal', '.modal', function(event) {
			$(this).find('.spinning').removeClass('spinning');
		});
		
		atEnd.forEach(function(f) {
			try { f(); } catch (e) { console.log(e); }
		});
		
		atEnd = [];
	}

	$(window).on('finish-page-script', function() { 
		$(document.body).addClass('loaded');
		$(document.documentElement).addClass('loaded');
	});
	$(window).on('load', function() { 
		$(document.body).addClass('loaded'); 
		$(document.documentElement).addClass('loaded'); 
	});
	
	return BLX;
})(window.BLX || {});
